import { runtime, Runtime } from './envRuntime';

export default function (data: any, isEncrypt = true) {
  if (!isEncrypt || !window.JSEncrypt) {
    return;
  }

  const encryptParamsList = [
    'pay_password',
    'userid',
    'recharge_ts',
    'launch_url',
    'pay_token',
    'total_fee',
    'trans_id',
    'nb_source',
    'has_touchid',
    'has_faceid',
    'model_key',
    'need_update_soter_key',
    'support_finger_type',
    'google_fingerprint_locked',
    'pay_type',
    'verify_type',
    'extra_data',
    'attach_params',
    'is_gray_unitepay',
    'is_sign_bindpay',
    'only_need_sms',
    'payId',
    'paysms',
    'need_bindcard',
    'voicecode',
    'user_name',
    'identity_type',
    'bank_card',
    'submit_url',
    'bank_name',
    'identity_no',
    'bankcard_no',
    'user_cellphone',
    'loading_text',
    'loading_display_style',
  ];
  const jsencrypt = new JSEncrypt();
  // tslint:disable-next-line:max-line-length
  let publicKey =
    '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvMKXHdrD/aIWRL/96PCJrPuFzsnaPKblOqt1BTp7wninNmZgZ4obAmpzupa1rI+kIhS8EVXlJ3KMPdH0Zni78L2fItjzAOwKeDgi5P5iluRNfujspJI4YCZyQtXjonIIQh1RVPFWsDr33Wry2vsEcRS8DXONVu1G1Fy5+zn3Z7nloRggNELnag2NMHKmi+Uu3rXF5141lE1DXD+/MsNrw1cnb479Bs+MzbEn9TBkWpbXXyUk+ebxsH/KyZP+KSlV0pGfQSqRJkxeHbnda9SeB89iTutjd75A0BzKCRJobefdfDGPjOf97v6wd+/UkkO2Du9ZGqxcuUrRsM3FgUT9RwIDAQAB-----END PUBLIC KEY-----';
  if (runtime >= Runtime.Test) {
    // tslint:disable-next-line:max-line-length
    publicKey =
      '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCQi60EVBaXsMRceGbboKjK+WaQkSUfosHmh67x0u7OMZGPogSvjixtGNUHpaXbsQn6C8BNl2BYV1K1AhRrD6sknlBxjO/PDNgszlAss1vFRlMW06OX/+4BehPvWqwj6kb7GSlfdY1grKZGzSmWmvPG55waes2g1ktUU17hC7bDqwIDAQAB-----END PUBLIC KEY-----';
  }
  jsencrypt.setPublicKey(publicKey);
  const encryptParams = [];
  /* eslint-disable */
  for (const key in data) {
    if (data.hasOwnProperty(key) && encryptParamsList.indexOf(key) !== -1 && data[key] !== '') {
      data[key] = jsencrypt.encrypt(String(data[key]));
      encryptParams.push(key);
    }
  }
  /* eslint-enable */

  if (encryptParams.length > 0) {
    data.encrypt_params = JSON.stringify(encryptParams);
  }
}
